import { SubPageLayout } from '../../../../staff/sub-page-layout';
import { SectionLayoutContainer } from '../section-layout.container';
import { PageLayoutProps } from '../../../../../shared/menu-component';

interface ActiveCaseSummaryProps {
    pageLayouts: PageLayoutProps[];
    isApplicantSection?: boolean;
}

export const ActiveCaseSummary: React.FC<ActiveCaseSummaryProps> = (props) => {
  return (
    <SubPageLayout>
        <div
            style={{
               marginBottom: '-90px'
            }}
        ></div>
      <SectionLayoutContainer pageLayouts={props.pageLayouts} isApplicantSection={props.isApplicantSection}/>
    </SubPageLayout>
  );
};
